$(document).ready(function () {
console.log($('#shopify-section-top-slider-wholesaleuser').length )
  if ($('#shopify-section-top-slider-wholesaleuser').length === 0) return

  var home_top_slider = $('.home-top-slider');

  home_top_slider.owlCarousel({
    center: true,
    autoplay: true,
    autoplayTimeout: 5000,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    items: 1,
    loop: true,
    margin: 10,
    dots: false,
  });

})  